import type { Ancestor } from "@/entities/ancestor";

import {
  getDirectParentByType,
  getLastAssetAncestor,
} from "@/entities/ancestor";

export const getAssetSelectOptionValue = (ancestors: Ancestor[]) => {
  const asset = getLastAssetAncestor(ancestors);

  if (!asset) return undefined;

  return {
    value: asset.id,
    label: asset.name,
    key: asset.id,
  };
};

export const getParentAssetSelectOptionValue = (
  ancestors: Ancestor[],
  currentAssetId: number
) => {
  const asset = getDirectParentByType(ancestors, "asset", currentAssetId);

  if (!asset) return undefined;

  return {
    value: asset.id,
    label: asset.name,
    key: asset.id,
  };
};
